import React from 'react';
import { Glyphicon,  Modal, Button } from "react-bootstrap";
import classes from './ModalMessage.css';
import QRCode from 'qrcode.react';

const alert = (props) => {
    let confirmElement = null;
    const inputClasses = [classes.InputElement];

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }
    confirmElement = 
        <div>
        <Modal show={props.showmodal} onHide={props.clickedCancel}>
            <Modal.Header closeButton className={props.classTitle}>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="white-space">
                {!props.invalid && props.isqrcode && <QRCode value={props.body} />}
                {!props.invalid && !props.isqrcode && <p className="white-space">{props.body}</p>}
                {props.invalid && props.body}
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn" onClick={props.clickedOk}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    </div>
    return (
        <div className={classes.Input}>
            {confirmElement}
        </div>
    );
};

export default alert;